import { Breadcrumb } from "antd";
import React, { useContext } from "react";
import { NavLink, useLocation, useParams, matchPath } from "react-router-dom";
import { InternalLinkNames, InternalLinks, InternalRoutes } from "../utils";
import { ThemeContext } from "../contexts";

export const BreadCrumbRouter = React.memo(() => {
  const theme = useContext(ThemeContext);
  const location = useLocation();
  const params = useParams();
  const currentPath = location.pathname;

  let routes = [];
  const rootPaths = [
    // InternalRoutes.Home,
    InternalRoutes.Users,
    InternalRoutes.Roles,
    InternalRoutes.TraderParams,
    InternalRoutes.StandingParams,
    InternalRoutes.Offers,
    InternalRoutes.SubmittedSets,
    InternalRoutes.TemplateSets,
    InternalRoutes.AckSets,
    InternalRoutes.SolveList,
    InternalRoutes.JsonViewerHome,
    InternalRoutes.DispatchTimesHistory,
    InternalRoutes.SolveCompositeResult,
    InternalRoutes.AutoStatusHistory
  ];
  //add rootPaths routes
  rootPaths.forEach(path => {
    if (currentPath.indexOf(path) >= 0)
      routes.push({
        path: path,
        breadcrumbName: InternalLinkNames[path]
      });
  });

  if (currentPath.indexOf(InternalRoutes.Solve) >= 0 && params.solveId) {
    const solveId = params.solveId;
    const bidSettlementDate = params.bidSettlementDate;
    routes.push({
      breadcrumbName: `Solver Run - ${solveId} (${bidSettlementDate})`,
      path: InternalLinks.Solve({
        solveId,
        bidSettlementDate
      })
    });
  }
  if (currentPath.indexOf(InternalRoutes.SolveResult) >= 0 && params.solveId) {
    const solveId = params.solveId;
    const bidSettlementDate = params.bidSettlementDate;
    routes.push({
      breadcrumbName: `Result`,
      path: InternalLinks.Solve({
        solveId,
        bidSettlementDate
      })
    });
  }
  if (currentPath.indexOf(InternalRoutes.AckSet) >= 0 && params.aemoTransactionId) {
    const aemoTransactionId = params.aemoTransactionId;
    routes.push({
      breadcrumbName: `Ack Set - ${aemoTransactionId}`,
      path: InternalLinks.AckSet({
        aemoTransactionId
      })
    });
  }
  if (currentPath.indexOf(InternalRoutes.TemplateSet) >= 0 && params.templateSetId) {
    const setId = params.templateSetId;
    routes.push({
      breadcrumbName: `Template Set - ${setId}`,
      path: InternalLinks.TemplateSet({
        templateSetId: setId
      })
    });
  }
  if (currentPath.indexOf(InternalRoutes.SubmittedSet) >= 0 && params.submittedSetId) {
    const setId = params.submittedSetId;
    routes.push({
      breadcrumbName: `Submitted Set - ${setId}`,
      path: InternalLinks.SubmittedSet({
        submittedSetId: setId
      })
    });
  }

  if (currentPath.indexOf(InternalRoutes.BidParam) >= 0 && params.parameterId) {
    const parameterId = params.parameterId;
    const duid = params.duid;
    const bidType = params.bidType;
    routes.push({
      breadcrumbName: `Parameter (${duid} - ${bidType} - ${parameterId})`,
      path: InternalLinks.BidParam({
        parameterId,
        duid,
        bidType
      })
    });
  }

  if (currentPath.indexOf(InternalRoutes.User) >= 0 && params.userId) {
    const userId = params.userId;
    routes.push({
      breadcrumbName: `User - ${userId}`,
      path: InternalLinks.User({
        userId: userId
      })
    });
  }
  if (currentPath.indexOf(InternalRoutes.Role) >= 0 && params.roleId) {
    const roleId = params.roleId;
    routes.push({
      breadcrumbName: `Role - ${roleId}`,
      path: InternalLinks.Role({
        roleId: roleId
      })
    });
  }

  // Check specific routes
  if (matchPath(InternalRoutes.DraftOffer, currentPath)) {
    routes.push({
      breadcrumbName: `Draft Bid (${params.duid} ${params.bidType} ${params.bidSettlementDate})`
    });
  } else if (matchPath(InternalRoutes.AlgoOffer, currentPath)) {
    routes.push({
      breadcrumbName: `Algo Bid (${params.duid} ${params.bidType} ${params.bidSettlementDate})`
    });
  } else if (matchPath(InternalRoutes.AckOffer, currentPath)) {
    routes.push({
      breadcrumbName: `Active Acknowledged Bid (${params.duid} ${params.bidType} ${params.bidSettlementDate})`
    });
  } else if (matchPath(InternalRoutes.AckSetOffer, currentPath)) {
    routes.push({
      breadcrumbName: `Ack Set Bid (${params.duid} ${params.bidType} ${params.bidSettlementDate})`
    });
  } else if (matchPath(InternalRoutes.SubmittedOffer, currentPath)) {
    routes.push({
      breadcrumbName: `Submitted Bid (${params.duid} ${params.bidType})`
    });
  } else if (matchPath(InternalRoutes.TemplateSetNew, currentPath)) {
    routes.push({ breadcrumbName: "New Template Set" });
  } else if (matchPath(InternalRoutes.TemplateOffer, currentPath)) {
    routes.push({
      breadcrumbName: `Template Bid (${params.duid} ${params.bidType})`
    });
  } else if (matchPath(InternalRoutes.BidAllocator, currentPath) || matchPath(InternalRoutes.Home, currentPath)) {
    routes.push({
      path: currentPath,
      breadcrumbName: InternalLinkNames[currentPath]
    });
  }

  // Convert routes to items format for Antd v5
  const items = routes.map((route, index) => {
    const isLast = index === routes.length - 1;
    return {
      title: isLast || !route.path ? (
        <span>{route.breadcrumbName}</span>
      ) : (
        <NavLink to={route.path}>{route.breadcrumbName}</NavLink>
      )
    };
  });

  // Don't render breadcrumb if there are no items
  if (items.length === 0) {
    return null;
  }

  return (
    <Breadcrumb
      style={{
        backgroundColor: theme.breadCrumbBackgroundColor,
        padding: "16px"
      }}
      items={items}
    />
  );
});
